module.exports = __webpack_public_path__ + "img/where-do-babies.b35bde8e.jpg";